import StatusFilter from 'app/common/ui-next/plain-status-filter'

export default StatusFilter
